import {
  Zap,
  Bot,
  Calendar,
  ChartLine,
  Database,
  Files,
  House,
  Route,
  Search,
  Settings,
  FileText,
  Shield,
  Shapes,
  Sparkles,
  Store,
} from "lucide-react";

import type { FeatureFlagName } from "@/shared/domain/featureFlags/FeatureFlagName";
import { Env } from "@/shared/environment";
import { Goto } from "@/shared/navigation/Goto";

export interface NavGroups {
  features: NavLink[];
  settingsAndGuides: NavLink[];
  admin: NavLink[];
}

export interface NavLink {
  name: string;
  link: string;
  icon: React.ElementType;
  isExternalLink?: boolean;
  /**
   * Render this link only when the named flag is on for the current org.
   * Hidden while loading or on fetch failure (fail-closed).
   */
  featureFlag?: FeatureFlagName;
}

export const navGroups: NavGroups = {
  features: [
    {
      name: "Home",
      link: Goto.route.Home,
      icon: House,
    },
    {
      name: "Search",
      link: Goto.route.Search,
      icon: Search,
    },
    {
      name: "Actions",
      link: "/actions",
      icon: Zap,
    },
    {
      name: "Action Hub",
      link: Goto.route.ActionHub,
      icon: Store,
    },
    {
      name: "Collections",
      link: Goto.route.Collections,
      icon: Shapes,
    },
    {
      name: "Devices",
      link: Goto.route.Devices,
      icon: Bot,
    },
    {
      name: "Metrics",
      link: "/metrics",
      icon: ChartLine,
      featureFlag: "release-metrics",
    },
    {
      name: "Sessions",
      link: Goto.route.Sessions,
      icon: Route,
      featureFlag: "release-sessions",
    },
    {
      name: "Agents",
      link: Goto.route.Agents,
      icon: Sparkles,
    },
  ],
  settingsAndGuides: [
    {
      name: "Settings",
      link: Goto.route.Settings.Root,
      icon: Settings,
    },
    {
      name: "Docs",
      isExternalLink: true,
      link: `https://${Env.docsDomain}`,
      icon: FileText,
    },
  ],
  admin: [
    {
      name: "Datasets",
      link: Goto.route.Datasets,
      icon: Database,
    },
    {
      name: "Events",
      link: Goto.route.Events,
      icon: Calendar,
    },
    {
      name: "Files",
      link: Goto.route.Files,
      icon: Files,
      featureFlag: "release-files-page",
    },
    {
      name: "Admin",
      link: Goto.route.Admin,
      icon: Shield,
    },
  ],
};
